<script lang="ts">
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import AuthModule from '@/store/modules/Auth';
import GeneralModule from '@/store/modules/General';

export default {
  name: 'ErrorHandleMixin',

  computed: {
    $general(): any {
      return getModule(GeneralModule, store);
    },
    $auth(): any {
      return getModule(AuthModule, store);
    }
  },

  methods: {
    async checkError(payload: { code?: number; message?: string } = {}) {
      const { code } = payload ?? {};
      if (code === undefined || code === null) return;

      // session expired / unauthorized
      if (code === 1002 || code === 1003 || code === 401) {
        try {
          await (this as any).$auth.Logout();
        } finally {
          (this as any).$general.toggleLoading(false);
          (this as any).$router.push('/login');
        }
      }
    }
  }
};
</script>
